import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { faUndo, faEye, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import RevenueTable from "./RevenueTable";
import axios from "axios";
import * as Yup from "yup";
import { type } from "jquery";
import { getUserType } from "../../utils/index";

if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),

    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),

    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),
  });
}

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;
//const [selectedValue, setSelectedValue] = useState([]);

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

let financialYear = [];
// var i = 0;  let currentYear = new Date().getFullYear();
// financialYear.push({ id: (currentYear + 1) , value: (currentYear )  + "-" + (currentYear + 1) })
// for (; i <= 10; i++) {
//   financialYear.push({ id: currentYear , value: (currentYear - 1)  + "-" + currentYear });
//   --currentYear;
// }

var tableCounter = 0;
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class RevenueReport extends React.Component {
  groupId = { value: "" };
  state = {
    chargeTypeSelected: [],
    brandSelected: [],
    landloardList: [],
    occupierList: [],
    selectedValue: [],
    setSelectedValue: [],
    leaseSelected: [],
    countries: [],
    monthsArr: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    assetsList: [],
    assetTypeList: [],
    assetTypeSelected: [],
    redirect: false,
    states: [],

    landloardCompanyList: [],
    financialYearOne: "",
    financialYearTwo: "",

    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",

    leaseList: [],
    formResponseData: [],
    formResponseData1: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    leaseType: "",
    leaseTypes: [],
    initialValues: {
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      landloardName: "",
      landloardId: "",
      OccupierName: "",
      occupierId: "",
      brandCatId: "",
      brandName: [],
      leaseId: "",
      chargeTypeSelected: [],
      financialYear: "",
      chargeType: "",
      financialYearOne: "Period 1",
      financialYearTwo: "Period 2",
      landloardCompanyName: "",
      landloardCompanyId: "",
      leaseType: "",
      modelValue: 'All',
      modelId: 'All',
      assetTypeId: "",

    },
  };

  componentDidMount() {
    this.initialiseAllData();
    
  }

  componentDidUpdate() { }

  frequencyChange(e) {
    console.log(e, "eee");
    this.state.initialValues.freqId = e.value;

    this.state.frequencySelected = {
      value: e.value,
      label: e.label,
    };

    // for (let i = 0; i < e.length; i++) {
    //   this.state.initialValuesAlertSettings.freqId.push(e[i].value);
    //   this.state.frequencySelected.push({
    //     value: e[i].value,
    //     label: e[i].label,
    //   });
    // }
    this.setState({});
  }


  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  initialiseAllData = () => {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/fetch-lease-types`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.getAssetTypes();
  }

  getAssetTypes = () => {
    let self = this;
    axios({
      method: 'GET',
      url: `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-with-filters?city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}
      `,
      headers: headers
    }).then((response) => {
      self.setState({
        assetTypeList: response.data
      });
    });
  }

  getAssetsListByAssetType = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-asset-lists?asset_type_ids=
      ${this.state.initialValues.assetTypeId}&city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_type") {
      this.state.initialValues.modelId = newValue.value;
      this.state.initialValues.modelValue = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type

      this.state.leaseSelected = [];
      if (newValue.length == 0) {
        this.state.initialValues.leaseId = "";
      } else {
        this.state.initialValues.leaseId = [];
      }
      if (newValue.length > 0 && newValue[0].value == 0) {
        this.state.leaseSelected.push({
          value: newValue[0].value,
          label: newValue[0].label,
        });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(this.state.leaseList[i].id);
          }
        }
      } else {
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push(newValue[i].value);
          this.state.selectedValue.push(newValue[i].value);
          this.state.leaseSelected.push({
            value: newValue[i].value,
            label: newValue[i].label,
          });
        }
      }

    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

        this.getAssetTypes();

    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByBrand();
      this.getAssetTypes();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_type") {

      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";
      
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetTypeId.push(newValue[i].value);
        this.state.assetTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByAssetType();

    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-revenue-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId +
        "&leaseType=" + this.state.leaseType + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_charge_type") {
      this.state.initialValues.chargeTypeSelected = [];
      this.state.chargeTypeSelected = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.chargeTypeSelected.push(newValue[i].value);
        this.state.chargeTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
    } else if (actionMeta == "change_financial_yearone") {
      //change_lease_month
      this.state.initialValues.financialYearIdOne = newValue.value;
      this.state.initialValues.financialYearOne = newValue.label;
    } else if (actionMeta == "change_financial_yeartwo") {
      //change_lease_month
      this.state.initialValues.financialYearIdTwo = newValue.value;
      this.state.initialValues.financialYearTwo = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else if (actionMeta == "change_occupier") {
      //brandName
      this.state.initialValues.occupierId = newValue.value;
      this.state.initialValues.occupierName = newValue.label;
    } else if (actionMeta == "change_landloard_company") {
      this.state.initialValues.landloardCompanyId = newValue.value;
      this.state.initialValues.landloardCompanyName = newValue.label;
    } else if (actionMeta == "lease_type") {
      this.state.initialValues.leaseType = newValue;
      this.state.leaseType = newValue.label;
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-revenue-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId +
        "&leaseType=" + newValue.label + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_landloard") {
      //brandName
      this.state.initialValues.landloardId = newValue.value;
      this.state.initialValues.landloardName = newValue.label;

      //
      fetch(
        `${apiUrl.apiUrl.url}/landlord/get-group-companies/?id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            landloardCompanyList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };

  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">
                  Lease Report -{" "}
                  {getUserType() == "Occupier" ? "Escalation" : "Escalation"}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.leaseSelected = [];
            this.state.initialValues.chargeTypeSelected = [];
            this.state.chargeTypeSelected = [];
            this.state.financialYearOne = "";
            this.state.financialYearTwo = "";
            this.state.counter = Math.random();
            this.setState({});

            this.state.assetTypeSelected = [];
            this.state.initialValues.assetTypeId = [];
            this.initialiseAllData();

          }}
          onSubmit={(values, actions) => {
            if (!this.validator.allValid()) {
              this.validator.showMessages();
              return false;
            }

            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;

            var counter = this.state.counter + 1;
            console.log(counter, "counter", form_config);
            this.state.counter = Math.random();
            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];
            this.setState({});
            return false;
            var headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            fetch(
              `${apiUrl.apiUrl.url}/sales-input/fetch-revenue-details?` + prm,
              { headers }
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                //this.setState({  });
                tableCounter = 0;
                this.setState({
                  formResponseData: data.data,
                  monthsArr: data.monthsArr,
                });
                this.setState({ counter: counter });
                this.setState({
                  exportUrl:
                    `${apiUrl.apiUrl.url}/sales-input/fetch-revenue-details?export=true&` +
                    prm,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      {/* First section */}
                      <div className="newGridSectionInner">
                        <label>Country</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="countryId"
                            isSearchable={true}
                            onChange={(e) => {
                              this.handleChangeCountry(e, "changecountry");
                            }}
                            value={{
                              label: this.state.initialValues.countryName,
                              value: this.state.initialValues.countryId,
                            }}
                            options={this.state.countries.map((item) => ({
                              label: item.country_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="countryId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Second section */}
                      <div className="newGridSectionInner">
                        <label>Brand Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="brandId"
                            isMulti
                            closeMenuOnSelect={true}
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_brand");
                            }}
                            value={this.state.brandSelected}
                            options={this.state.brandList.map((item) => ({
                              label: item.brand_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="brandId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Third section */}
                      <div className="newGridSectionInner">
                        <label>State</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={{
                              label: this.state.initialValues.state_name,
                              value: this.state.initialValues.state_id,
                            }}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="stateId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      
                      <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_type");
                            }}
                            value={this.state.assetTypeSelected}
                            options={this.state.assetTypeList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>

                      

                      {/* Fifth section */}
                      <div className="newGridSectionInner">
                        <label>District</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="districtId"
                            onChange={(e) => {
                              this.valueChange(e, "change_district");
                            }}
                            value={{
                              label: this.state.initialValues.districtName,
                              value: this.state.initialValues.districtId,
                            }}
                            options={this.state.districtList.map((item) => ({
                              label: item.district_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="districtId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Fourth section */}
                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message(
                            "Asset Name",
                            this.state.initialValues.assetId,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>
                      

                      {/* Seventh section */}
                      <div className="newGridSectionInner">
                        <label>City</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="cityId"
                            onChange={(e) => {
                              this.valueChange(e, "change_city");
                            }}
                            value={{
                              label: this.state.initialValues.cityName,
                              value: this.state.initialValues.cityId,
                            }}
                            options={this.state.cityList.map((item) => ({
                              label: item.city_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="cityId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Sixth section */}
                      <div className="newGridSectionInner">
                        <label>Model Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="modelType"
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_type");
                            }}
                            value={{
                              label: this.state.initialValues.modelValue,
                              value: this.state.initialValues.modelId,
                            }}
                            options={this.state.leaseTypes.map((item) => ({
                              label: item.value,
                              value: item.label,
                            }))}
                          />
                          <ErrorMessage
                            name="modelType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Eighth section */}
                      <div className="newGridSectionInner">
                        <label>Lease Number</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_number");
                            }}
                            value={this.state.leaseSelected}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="leaseSelected"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Ninth section */}
                      <div className="newGridSectionInner">
                        <label>Frequency</label>
                        <div className="position-relative">
                          <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                            name="frequencyDataValue"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.frequencyChange(e);
                            }}
                            value={this.state.frequencySelected}
                            options={[
                              { label: "6 Months", value: 6 },
                              { label: "5 Months", value: 5 },
                              { label: "4 Months", value: 4 },
                              { label: "3 Months", value: 3 },
                              { label: "2 Months", value: 2 },
                              { label: "1 Month", value: 1 },
                              { label: "15 Days", value: "15 Days" },
                            ].map((item) => ({
                              label: item.label,
                              value: item.value,
                            }))}
                          />
                          {this.validator.message(
                            "chargeType",
                            this.state.frequencySelected,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      {/* Tenth section */}
                      <div className="newGridSectionInner">
                        <label>Cost Center</label>
                        <div className="position-relative">
                          <input
                            className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                            name="costcenter"
                            onChange={(e) => {
                              this.state.initialValues.costCenter = e.target.value;
                              this.setState({});
                            }}
                          />
                          <ErrorMessage
                            name="costCenter"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        View
                      </button>
                      <button type="reset" className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Country
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="countryId"
                                isSearchable="true"
                                onChange={(e) => {
                                  this.handleChangeCountry(e, "changecountry");
                                }}
                                value={{
                                  label: this.state.initialValues.countryName,
                                  value: this.state.initialValues.countryId,
                                }}
                                options={this.state.countries.map((item) => ({
                                  label: item.country_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="countryId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Brand Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="brandId"
                                isMulti
                                closeMenuOnSelect={true}
                                onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  this.valueChange(e, "change_brand");
                                }}
                                value={this.state.brandSelected}
                                options={this.state.brandList.map((item) => ({
                                  label: item.brand_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="brandId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="stateId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_state");
                                }}
                                value={{
                                  label: this.state.initialValues.state_name,
                                  value: this.state.initialValues.state_id,
                                }}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="stateId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onInputChange={this.getAssetsList}
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_asset_name");
                                }}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              {this.validator.message(
                                "Asset Name",
                                this.state.initialValues.assetId,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="districtId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_district");
                                }}
                                value={{
                                  label: this.state.initialValues.districtName,
                                  value: this.state.initialValues.districtId,
                                }}
                                options={this.state.districtList.map((item) => ({
                                  label: item.district_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="districtId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Model Type
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="modelType"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_lease_type");
                                }}
                                value={{
                                  label: this.state.initialValues.modelValue,
                                  value: this.state.initialValues.modelId,
                                }}
                                options={this.state.leaseTypes.map((item) => ({
                                  label: item.value,
                                  value: item.label,
                                }))}
                              />


                              <ErrorMessage
                                name="modelType"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="cityId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_city");
                                }}
                                value={{
                                  label: this.state.initialValues.cityName,
                                  value: this.state.initialValues.cityId,
                                }}
                                options={this.state.cityList.map((item) => ({
                                  label: item.city_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="cityId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Lease Number
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="leaseId"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.valueChange(e, "change_lease_number");
                                }}
                                value={this.state.leaseSelected}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="leaseSelected"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Frequency
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="frequencyDataValue"
                                //isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.frequencyChange(e);
                                }}
                                value={this.state.frequencySelected}
                                options={[
                                  { label: "6 Months", value: 6 },
                                  { label: "5 Months", value: 5 },
                                  { label: "4 Months", value: 4 },
                                  { label: "3 Months", value: 3 },
                                  { label: "2 Months", value: 2 },
                                  { label: "1 Months", value: 1 },
                                  {
                                    label: "15 Days",
                                    value: "15 Days",
                                  },
                                ].map((item) => ({
                                  label: item.label,
                                  value: item.label,
                                }))}
                              />

                              {this.validator.message(
                                "chargeType",
                                this.state.frequencySelected,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Cost Center
                            </label>
                            <div className="col-sm-7">
                              <input
                                className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                name="costcenter"
                                // onInputChange={this.handleChange}
                                onChange={(e) => {
                                  //handleChange(e);
                                  console.log(e, "lineno 1076")
                                  this.state.initialValues.costCenter = e.target.value;
                                  this.setState({})
                                }}

                              />

                              <ErrorMessage
                                name="costCenter"
                                component="div"
                                className="text-red"
                              />
                              { }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer">
                          <div>
                            <button type="submit" d1isabled={isSubmitting}>
                              View
                            </button>
                            <button type="reset" d1isabled={isSubmitting}>
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>

        <RevenueTable
          key={this.state.counter}
          formConfig={this.state.formConfig}
          fetchUrl={apiUrl.apiUrl.url + "/rent-calculation/escalation-report?"}
          showExport={true}
        />
      </>
    );
  }
}

export default withRouter(RevenueReport);
